import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardAdmin from './pages/DashboardAdmin';
import Fiches from './pages/Fiches';
import FicheDetail from './pages/FicheDetail';
import FicheDetailRoute from './components/FicheDetailRoute';
import Planning from './pages/Planning';
import PlanningCommercial from './pages/PlanningCommercial';
import PlanningDep from './pages/PlanningDep';
import PlanningHebdomadaire from './pages/PlanningHebdomadaire';
import PlanningHebdoIos from './pages/PlanningHebdoIos';
import AffectationDep from './pages/AffectationDep';
import Statistiques from './pages/Statistiques';
import StatistiquesRDV from './pages/StatistiquesRDV';
import StatistiquesFiches from './pages/StatistiquesFiches';
import Affectation from './pages/Affectation';
import SuiviTelepro from './pages/SuiviTelepro';
import SuiviAgentsQualif from './pages/SuiviAgentsQualif';
import SuiviAgents from './pages/SuiviAgents';
import ProductionQualif from './pages/ProductionQualif';
import KPIQualification from './pages/KPIQualification';
import KPIAgentQualification from './pages/KPIAgentQualification';
import KPIs from './pages/KPIs';
import StatistiquesV2 from './pages/StatistiquesV2';
import ControleQualite from './pages/ControleQualite';
import Alertes from './pages/Alertes';
import AlertePlanningGate from './components/AlertePlanningGate';
import Remarques from './pages/Remarques';
import AuditRDV from './pages/AuditRDV';
import RdvCreneauCodeBypass from './pages/RdvCreneauCodeBypass';
import ListeCompletudes from './pages/ListeCompletudes';
import CompteRendu from './pages/CompteRendu';
import CompteRenduPending from './pages/CompteRenduPending';
import Tracking from './pages/Tracking';
import { canAccessTrackingPage } from './utils/trackingAccess';
import Phase3 from './pages/Phase3';
import Permissions from './pages/Permissions';
import ImportMasse from './pages/ImportMasse';
import Messages from './pages/Messages';
import Users from './pages/Users';
import StatsAgentsQualite from './pages/StatsAgentsQualite';
import Management from './pages/Management';
import Decalages from './pages/Decalages';
import Validation from './pages/Validation';
import DemandesInsertion from './pages/DemandesInsertion';
import Notifications from './pages/Notifications';
import Signatures from './pages/Signatures';
import SignaturesAujourdhui from './pages/SignaturesAujourdhui';
import CQSignatures from './pages/CQSignatures';
import RendezVousVue from './pages/RendezVousVue';
import StatAffiliation from './pages/StatAffiliation';
import AssistanceIA from './pages/AssistanceIA';
import MesRappels from './pages/MesRappels';
import RappelsBureau from './pages/RappelsBureau';
import SystemMessages from './pages/SystemMessages';
import MonProfil from './pages/MonProfil';
import MonEquipe from './pages/MonEquipe';
import CodeSecours from './pages/CodeSecours';
import BackofficeLoginRoute from './components/BackofficeLoginRoute';
import Layout from './components/Layout';
import HomeRedirect from './components/HomeRedirect';
import ForceDesktopViewport from './components/ForceDesktopViewport';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ForceDesktopViewport />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<HomeRedirect />} />
          <Route path="dashboard" element={<ProtectedRoute permission="dashboard_view"><Dashboard /></ProtectedRoute>} />
          <Route path="recherche-fiches" element={<ProtectedRoute permission="dashboard_view"><DashboardAdmin /></ProtectedRoute>} />
          <Route path="fiches" element={<ProtectedRoute permission="fiches_view"><Fiches /></ProtectedRoute>} />
          <Route path="fiches/:id" element={<ProtectedRoute permission="fiches_detail"><FicheDetailRoute /></ProtectedRoute>} />
          <Route path="planning" element={<ProtectedRoute permission="planning_view"><Planning /></ProtectedRoute>} />
          <Route path="planning-dep" element={<ProtectedRoute permission="planning_dep_view"><PlanningDep /></ProtectedRoute>} />
          <Route path="planning-commercial" element={<ProtectedRoute permission="planning_commercial_view"><PlanningCommercial /></ProtectedRoute>} />
          <Route path="planning-hebdomadaire" element={<ProtectedRoute permission="planning_view"><PlanningHebdomadaire /></ProtectedRoute>} />
          <Route
            path="planning-hebdo-ios"
            element={
              <ProtectedRoute permission={null} customCheck={(_item, user) => Number(user?.fonction) === 1}>
                <PlanningHebdoIos />
              </ProtectedRoute>
            }
          />
          <Route path="rdv-vue" element={<ProtectedRoute permission="planning_view"><RendezVousVue /></ProtectedRoute>} />
          <Route
            path="stat-affiliation"
            element={
              <ProtectedRoute permission={null} allowFunctions={[11]}>
                <StatAffiliation />
              </ProtectedRoute>
            }
          />
          <Route path="affectation-dep" element={<ProtectedRoute permission="affectation_view"><AffectationDep /></ProtectedRoute>} />
          <Route path="statistiques" element={<ProtectedRoute permission="statistiques_view"><Statistiques /></ProtectedRoute>} />
          <Route path="statistiques-rdv" element={<ProtectedRoute permission="statistiques_rdv_view"><StatistiquesRDV /></ProtectedRoute>} />
          <Route path="statistiques-fiches" element={<ProtectedRoute permission="statistiques_fiches_view"><StatistiquesFiches /></ProtectedRoute>} />
          <Route path="assistance-ia" element={<ProtectedRoute permission="assistance_ia_view"><AssistanceIA /></ProtectedRoute>} />
          <Route path="affectation" element={<ProtectedRoute permission="affectation_view"><Affectation /></ProtectedRoute>} />
          <Route path="suivi-telepro" element={<ProtectedRoute permission="suivi_telepro_view"><SuiviTelepro /></ProtectedRoute>} />
          <Route path="suivi-agents-qualif" element={<ProtectedRoute permission="suivi_agents_view"><SuiviAgentsQualif /></ProtectedRoute>} />
          <Route path="suivi-agents" element={<ProtectedRoute permission="suivi_agents_view"><SuiviAgents /></ProtectedRoute>} />
          <Route path="production-qualif" element={<ProtectedRoute permission="production_qualif_view"><ProductionQualif /></ProtectedRoute>} />
          <Route path="kpi-qualification" element={<ProtectedRoute permission="kpi_qualification_view"><KPIQualification /></ProtectedRoute>} />
          <Route path="mes-indicateurs" element={<ProtectedRoute permission="agent_qualification_kpis" allowFunctions={[3]}><KPIAgentQualification /></ProtectedRoute>} />
          <Route path="kpis" element={<ProtectedRoute permission="kpis_view"><KPIs /></ProtectedRoute>} />
          <Route path="statistiques-v2" element={<ProtectedRoute permission="statistiques_v2_view"><StatistiquesV2 /></ProtectedRoute>} />
          <Route path="controle-qualite" element={<ProtectedRoute permission="controle_qualite_view"><ControleQualite /></ProtectedRoute>} />
          <Route path="alertes" element={<ProtectedRoute permission="controle_qualite_view" allowFunctions={[3, 2, 12]}><Alertes /></ProtectedRoute>} />
          <Route path="alerte-planning" element={<AlertePlanningGate />} />
          <Route path="remarques" element={<ProtectedRoute permission="controle_qualite_view" allowFunctions={[2, 12]}><Remarques /></ProtectedRoute>} />
          <Route path="audit-rdv" element={<ProtectedRoute permission="controle_qualite_view" allowFunctions={[4, 13]}><AuditRDV /></ProtectedRoute>} />
          <Route path="bypass-creneau" element={<ProtectedRoute permission={null} allowFunctions={[1, 7, 11, 13]}><RdvCreneauCodeBypass /></ProtectedRoute>} />
          <Route path="liste-completudes" element={<ProtectedRoute permission={null} allowFunctions={[4, 11, 13, 14]}><ListeCompletudes /></ProtectedRoute>} />
          <Route path="compte-rendu" element={<ProtectedRoute permission="compte_rendu_view"><CompteRendu /></ProtectedRoute>} />
          <Route
            path="tracking"
            element={
              <ProtectedRoute
                permission={null}
                allowFunctions={[11]}
                customCheck={(_item, u) => canAccessTrackingPage(u)}
              >
                <Tracking />
              </ProtectedRoute>
            }
          />
          <Route path="compte-rendu-pending" element={<ProtectedRoute permission={null} customCheck={(item, user) => [1, 2, 5, 7, 13].includes(Number(user?.fonction))}><CompteRenduPending /></ProtectedRoute>} />
          <Route path="phase3" element={<ProtectedRoute permission="phase3_view"><Phase3 /></ProtectedRoute>} />
          <Route path="permissions" element={<ProtectedRoute permission="config_permissions" excludeFunctions={[8]}><Permissions /></ProtectedRoute>} />
          <Route path="import-masse" element={<ProtectedRoute permission="import_masse_view" excludeFunctions={[8]}><ImportMasse /></ProtectedRoute>} />
          <Route path="messages" element={<ProtectedRoute permission="messages_view"><Messages /></ProtectedRoute>} />
          <Route path="users" element={<ProtectedRoute permission="users_view"><Users /></ProtectedRoute>} />
          <Route path="stats-agents-qualite" element={<ProtectedRoute permission="stats_agents_qualite_view"><StatsAgentsQualite /></ProtectedRoute>} />
          <Route path="management" element={<ProtectedRoute permission="management_view" excludeFunctions={[8]}><Management /></ProtectedRoute>} />
          <Route path="decalages" element={<ProtectedRoute permission="decalage_view"><Decalages /></ProtectedRoute>} />
          <Route path="validation" element={<ProtectedRoute permission="validation_view" allowFunctions={[13]}><Validation /></ProtectedRoute>} />
          <Route path="mes-rappels" element={<ProtectedRoute permission="dashboard_view" allowFunctions={[6, 13, 14]}><MesRappels /></ProtectedRoute>} />
          <Route path="mon-equipe" element={<ProtectedRoute permission={null} allowFunctions={[2, 12, 13, 14]}><MonEquipe /></ProtectedRoute>} />
          <Route path="rappels-bureau" element={<ProtectedRoute permission={null} allowFunctions={[13]}><RappelsBureau /></ProtectedRoute>} />
          <Route path="demandes-insertion" element={<ProtectedRoute permission="demandes_insertion_view"><DemandesInsertion /></ProtectedRoute>} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="signatures" element={<ProtectedRoute permission="signatures_view"><Signatures /></ProtectedRoute>} />
          <Route path="signatures-aujourdhui" element={<ProtectedRoute permission="signatures_view"><SignaturesAujourdhui /></ProtectedRoute>} />
          <Route path="cq-signatures" element={<ProtectedRoute permission={null} allowFunctions={[1, 11]}><CQSignatures /></ProtectedRoute>} />
          <Route path="system-messages" element={<ProtectedRoute permission="management_view"><SystemMessages /></ProtectedRoute>} />
          <Route path="mon-profil" element={<ProtectedRoute permission={null} allowFunctions={[1, 2, 6, 7, 8, 9, 11, 12, 13, 14]}><MonProfil /></ProtectedRoute>} />
          <Route
            path="code-secours"
            element={
              <BackofficeLoginRoute>
                <CodeSecours />
              </BackofficeLoginRoute>
            }
          />
        </Route>
        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;

